"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseComponentSymbol = void 0;
exports.BaseComponentSymbol = Symbol('BaseComponent');
//# sourceMappingURL=baseComponent.js.map